<template>
  <SntSelect
    :value="value"
    :width="width"
    :height="height"
    :items="filteredItems"
    :loading="$apollo.loading"
    :has-next-page="productList.hasNextPage"
    :callback="fetchMore"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :item-value="itemValue"
    item-text="name"
    hide-details
    @input="$emit('input', $event)" />
</template>

<script>
import gql from 'graphql-tag'
import SntSelect from '../form/SntSelect.vue'

export default {
  components: {
    SntSelect
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'ทั้งหมด'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    clearable: Boolean,
    disabled: Boolean
  },
  apollo: {
    productList: {
      fetchPolicy: 'network-only',
      query: gql`
        query (
          $page: Int
          $perPage: Int
        ) {
          productList(
            page: $page
            perPage: $perPage
          ) {
            hasNextPage
            nodes {
              id
              name
            }
          }
        }
      `,
      variables () {
        return {
          page: 1,
          perPage: this.perPage
        }
      },
      result ({ data }) {
        this.onLoaded(data)
      }
    }
  },
  data () {
    return {
      page: 1,
      perPage: 15,
      itemValue: 'id',
      productList: {
        nodes: [],
        hasNextPage: false
      }
    }
  },
  computed: {
    filteredItems () {
      return this.productList.nodes
    }
  },
  methods: {
    fetchMore () {
      this.page += 1
      return this.$apollo.queries.productList.fetchMore({
        variables: {
          page: this.page,
          perPage: this.perPage
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const { hasNextPage, nodes } = fetchMoreResult.productList
          return ({
            productList: {
              __typename: previousResult.productList.__typename,
              nodes: this.$_.uniqBy([
                ...previousResult.productList.nodes,
                ...nodes
              ], this.itemValue),
              hasNextPage
            }
          })
        }
      })
    },
    onLoaded (data) {
      this.$emit('loaded', data)
    }
  }
}
</script>
